import React from 'react';
import { Label } from '@repo/ui/components/Label';
import { cn } from '@repo/ui/utils';

interface FormFieldProps {
  label: React.ReactNode;
  labelSuffix?: React.ReactNode;
  htmlFor: string;
  error?: string | null;
  errorId?: string;
  className?: string;
  labelClassName?: string;
  required?: boolean;
  children: React.ReactNode;
}

export function FormField({
  label,
  labelSuffix,
  htmlFor,
  error,
  errorId,
  className,
  labelClassName,
  required,
  children,
}: FormFieldProps) {
  return (
    <div className={cn('flex', 'flex-col', 'gap-1', className)}>
      <Label
        htmlFor={htmlFor}
        className={cn(labelClassName, 'flex', 'items-center')}
      >
        {label}
        {required && (
          <span aria-hidden="true" className="ml-1">
            *
          </span>
        )}
        {labelSuffix}
      </Label>
      {children}
      {errorId ? (
        <p
          id={errorId}
          role="alert"
          aria-atomic="true"
          className={cn(
            'text-sm',
            'text-destructive-ghost-foreground',
            !error && 'sr-only'
          )}
        >
          {error}
        </p>
      ) : (
        error && (
          <p className={cn('text-sm', 'text-destructive-ghost-foreground')}>
            {error}
          </p>
        )
      )}
    </div>
  );
}
